import { InterfaceElement }  from './asd-properties/asd-ie/asd-interfaceElement';
import { Header }  from './asd-properties/asd-header';
import { Error }  from './asd-properties/asd-error';
import { ViewArea }  from './asd-properties/asd-viewArea';
import { Grid }  from './asd-properties/asd-grid';
import { DownloadFile } from './asd-properties/asd-downloadFile';
import { HTMLBase } from '../html/html';

export class AsdBase{
  Header : Header;
  ViewAreas : ViewArea[];
  Error : Error;
  InterfaceElements: InterfaceElement[];
  DownloadFile : DownloadFile;


  /*Grid Layout*/
  Grid : Grid;
}
